import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach ?lang= automatically based on current localStorage
api.interceptors.request.use((config) => {
  const lang = typeof window !== "undefined" ? localStorage.getItem("bf_lang") || "en" : "en";
  config.params = { ...(config.params || {}), lang };
  return config;
});

export async function streamChat({ sessionId, message, lang = "en", childProfile = null, onDelta, onDone, onError }) {
  try {
    const res = await fetch(`${API}/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message, lang, child_profile: childProfile }),
    });
    if (!res.ok || !res.body) {
      onError?.(new Error("Connexion impossible"));
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n\n");
      buffer = lines.pop() ?? "";
      for (const block of lines) {
        if (!block.trim()) continue;
        if (block.startsWith("event: done")) { onDone?.(); return; }
        if (block.startsWith("event: error")) {
          const msg = block.split("data:")[1]?.trim() ?? "Erreur";
          onError?.(new Error(msg));
          return;
        }
        const dataLine = block.split("\n").find((l) => l.startsWith("data:"));
        if (dataLine) {
          const chunk = dataLine.slice(5).replace(/\\n/g, "\n");
          onDelta?.(chunk.startsWith(" ") ? chunk.slice(1) : chunk);
        }
      }
    }
    onDone?.();
  } catch (e) {
    onError?.(e);
  }
}
